import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { type State } from "@App/state";
import { PremiumServiceTypes } from "@App/types/enums";

/**
 * usePremiumServiceObserver observes the premiumServices array in the state and returns a boolean that is true, if the given premiumServiceType is found in the
 * list of premiumServices.
 *
 * @param premiumServiceType
 */
export const usePremiumServiceObserver = (premiumServiceType: PremiumServiceTypes): [boolean] => {
  const premiumServices = useSelector((state: State) => state.orders.premiumServices);
  const [premiumServiceSelected, setPremiumServiceSelected] = useState(false);

  useEffect(() => {
    setPremiumServiceSelected(
      premiumServices.some((premiumService) => premiumService.type === premiumServiceType),
    );
  }, [premiumServices]);

  return [premiumServiceSelected];
};
